import { useFormContext } from 'react-hook-form';

import { AmendmentTypes } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { TestIds } from '../../../create-amendment.helper';
import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export function ChangeType() {
  const { unregister } = useFormContext<FormFields>();
  const changeTypesList = useListBuilder(changeTypes);

  return (
    <S.FormLabel>
      Change type
      <V2.TextDropdownRhf
        name="changeType"
        data-testid={TestIds.changeType}
        items={changeTypesList}
        placeholder="Select type"
        aria-label="Change type"
        rules={{
          deps: ['payrunType'],
          required: 'This field is required',
        }}
        onChange={(value) => {
          if (value !== AmendmentTypes.PAYRUN) {
            unregister('payrunType');
            unregister('payrun');
            unregister('adhocEffectiveDate');
            unregister('adhocPayDate');
          }
        }}
      />
    </S.FormLabel>
  );
}

const changeTypes = [
  {
    key: AmendmentTypes.PAYRUN,
    value: 'Payrun',
  },
  {
    key: AmendmentTypes.PERMANENT,
    value: 'Permanent',
  },
  {
    key: AmendmentTypes.RECURRING,
    value: 'Recurring',
  },
];
